import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// The warning banner's own tint, so a flagged row reads as the restriction the
// banner has already named rather than as a second, unrelated problem.
export const OUT_OF_SCOPE_ROW_SX = { backgroundColor: '#FFF4E5' };

// Flags one selection the template's constraint disallows, sitting under the
// row's name so that it names the offending row rather than announcing that a
// violation exists somewhere: the form creator cannot save until it is cleared,
// so they have to be able to find it among however many selections they have.
//
// A saved audience can hold such a row without the form creator having done
// anything wrong - the template is patched after forms exist, and rosters roll
// over every academic year - so the row is left visible with its own remove
// control rather than stripped out from under them.
export default function OutOfScopeFlag(): React.ReactElement {
  return (
    // Indented past the row's own icon so that it hangs under the name it is
    // flagging rather than reading as a row of its own.
    <Stack direction="row" spacing={0.5} alignItems="center" pl={4}>
      <WarningAmberIcon fontSize="small" color="warning" />
      <Typography variant="caption" color="warning.dark">Not allowed by this template - remove to save</Typography>
    </Stack>
  );
}
